<template>
	<div class="posts">
		<h2>Публикации</h2>
		<btn label="Создать публикацию" i="plus" @press="createPost()" size="medium"/>

		<i-button-toggle :options="postTypes" v-model="currentMode"/>

		<hr>
		<i-list :paginate="10" @input="openPost" :fields="listFields" :data="posts"/>
		<modal name="post-edit-modal" :height="510" :width="800" title="Редактирование публикации" :noFooter="false">
		 	<tabs>
		 		<tab title="Настройки">
		 			<i-form :scheme="formSchemes.main" :data="postToEdit" 
		 				    @input="postChanged" :showSaveButton="false"/>
		 		</tab>
		 		<tab title="RU">
		 			<i-form :scheme="formSchemes.ru" :data="postToEdit" 
		 				    @input="postChanged" :showSaveButton="false"/>
		 		</tab>
		 		<tab title="KZ">
		 			<i-form :scheme="formSchemes.kz" :data="postToEdit" 
		 				    @input="postChanged" :showSaveButton="false"/>
		 		</tab>
		 		<tab title="EN">
		 			<i-form :scheme="formSchemes.en" :data="postToEdit" 
		 				    @input="postChanged" :showSaveButton="false"/>
		 		</tab>
		 	</tabs>
		      <div slot="footer">
		        <btn l="Удалить"  t='d' s='m'  i='trash' @press="remove" pull='left'></btn>
		        <btn l="Сохранить" t='s' s='m'  i='save' @press="saveForm" pull='right'></btn>
		        <btn l="Отмена" t='df' s='m'  i='times' @press="cancel" pull='right'></btn>
		      </div>
		</modal>
	</div>
</template>

<script>
//import posts from "../../iwep.kz/assets/json/posts_multilang.json";
export default {

  name: 'posts',

  data () {
    return {
        currentMode:"publications",
        postTypes:[
        	{label:"Публикации", value:"publications"},
			{label:"События", value:"events"},
			{label:"На главной", value:"onMainPage"},
			{label:"Пресс релиз", value:"pressReleases"},
			{label:"Разделы сайта", value:"sections"}
        ],
    	listFields:[
	      {
	        "label": "№",
	        "type": "index"
	      },
	      {
			label: 'Вкл',
			name: 'enabled',
			type:'boolean'
		  },
	      {
			label: 'Превью',
			name: 'preview',
			type:'image'
		  },
	      {
	        "label": "ID",
	        "name": "_id"
	      },
	      {
	        "label": "Название",
	        "name": "content.ru.title"
	      },
	      /*{
	        "label": "Краткое Содержание",
	        "name": "content.ru.short"
	      },*/
	      {
			label: 'Событие',
			name: 'isEvent',
			type:'boolean'
		  },
		  {
			label: 'На главной',
			name: 'onMainPage',
			type:'boolean'
		  },{
			label: 'Пресс релиз',
			name: 'pressRelease',
			type:'boolean'
		  }
	    ],
	    //posts,
	    formSchemes:{
	    	main:{
				preview:{type:"image", label:"Превью (картинка)"},
				"content.ru.image_source":{type:"string", label:"Источник изображения"},
				source:{type:"string", label:"Источник"},
				authors:{type:"list", label:"Авторы"},
				date:{type:"date", label:"Дата публикации"},
				enabled:{type:'boolean',label:'Опубликовать'},
				onMainPage:{type:'boolean',label:'На главной странице'},
				isEvent:{type:'boolean',label:'Событие'},
				pressRelease:{type:'boolean',label:'Пресс релиз'},
				isSection:{type:'boolean',label:'Секция сайта'},
				section:{type:'string',label:'Секция сайта'}
	    	},
	    	ru:{
				"content.ru.title":{type:"string", label:"Название"},
				"content.ru.short":{type:"text", label:"Краткое описание", rows:6},
				"content.ru.text":{type:"wysiwyg", label:"Изменить содержание"},
				"content.ru.tags":{type:"string", label:"Тэги"},
				"content.ru.enabled":{type:'boolean',label:'Опубликовать'}
	    	},
	    	kz:{
				"content.kz.title":{type:"string", label:"Атауы"},
				"content.kz.short":{type:"text", label:"Қысқаша сипаттамасы", rows:6},
				"content.kz.text":{type:"wysiwyg", label:"Мазмұны жазу"},
				"content.kz.tags":{type:"string", label:"Тегтер"},
				"content.kz.enabled":{type:'boolean',label:'Опубликовать'}
	    	},
	    	en:{
				"content.en.title":{type:"string", label:"Name"},
				"content.en.short":{type:"text", label:"Short description", rows:6},
				"content.en.text":{type:"wysiwyg", label:"Change Content"},
				"content.en.tags":{type:"string", label:"Tags"},
				"content.en.enabled":{type:'boolean',label:'Опубликовать'}
	    	}
	    },
    	formScheme:{
    	},
    	postToEdit:{en:{},kz:{},ru:{}}
    }
  },
  created(){
  	_i.crudApi.makeStore(this,"posts",'content/posts');
  /*
    let self = this;
    if(!this.$store.state.posts)this.$store.registerModule('posts', {
      state: {
        list:[],
        total:0,
        loaded:false,
        current:0
      },
      mutations: {
        postUpdate(state, post){
  			let foundIndex = state.list.findIndex((p)=>{
  				if(p._id === post._id) return true;
  				else return false;
  			});
  			console.log(foundIndex)
  			if(foundIndex != -1){
  				state.list[foundIndex] = post;
  			} else {
  				state.list.push(post);
  			}
        }
      },
      actions:{
      	loadPosts({commit,state}, page = 0){
      		self.$http.get('content/posts',{params:{loadFull:true}}).then((res)=>{
      			let {error,posts,total} = res.body;
      			state.list = posts;
      			state.loaded = true;
      		});
      	}
      }
    });*/

    //if(!this.$store.state.posts.loaded)this.$store.dispatch('loadPosts');
  },
  methods:{
    cancel(){this.$store.commit('modalClose','post-edit-modal');},
    saveForm(){_i.bus.$emit('save-form');},
    remove(){
      this.$store.dispatch("postsRemoveCRUD",this.postToEdit._id);
      this.$store.commit('modalClose', "post-edit-modal");
    },
  	openPost(post){
  		console.log(post)
  		//console.log(post);
  		this.$store.commit('modalOpen', 'post-edit-modal');
  		this.postToEdit = post;
  	},
  	postChanged(post){
  		//this.$http.post('content/posts',{post}).then((res)=>{
  		//	let {error,post} = res.body;
		this.$store.dispatch('postsSaveCRUD', post);
		this.$store.commit('modalClose', 'post-edit-modal');
  		//});
  	},
  	createPost(){
  		this.$store.commit('modalOpen', 'post-edit-modal');
  		this.postToEdit = {content:{en:{},kz:{},ru:{}}};
  	}
  },
  computed:{
  	posts(){
  		let {currentMode} = this;
  		return this.$store.state.posts.list.filter((p)=>{
  			switch(currentMode){
  				case "publications":
  					return p.isEvent == false;
  				break
  				case "events":
  					return p.isEvent == true;
  				break
  				case "onMainPage":
  					return p.onMainPage == true;
  				break
  				case "pressReleases":
  					return p.pressRelease == true;
  				break
  				case "sections":
  					return p.isSection == true;
  				break

  			}
  		});
  	}

  }
}
</script>

<style lang="css" scoped>
.posts{
	padding:6px 12px;
}
</style>